import uuid from "react-uuid";
import { GridRowsProp } from "@mui/x-data-grid";

export const createData = function createData(
  firstname: string,
  lastname: string,
  email: string,
  notes: string,
  attended: string,
  toDelete: boolean
) {
  return { firstname, lastname, email, notes, attended, toDelete };
};

export const initialRows: GridRowsProp = [
  {
    id: uuid(),
    firstname: "",
    lastname: "",
    email: "",
    notes: "",
    attended: "",
    toDelete: false,
  },
];

export enum AttendanceStatus {
  "Attended" = "Attended",
  "NotAttended" = "Not Attended",
  "Blank" = "",
}

export enum Status {
  ATTENDED = "ATTENDED",
  DID_NOT_ATTEND = "DID_NOT_ATTEND",
  NONE = "NONE",
}

export enum AttendanceCreationMethod {
  NONE = "NONE",
  ADMIN = "ADMIN",
  SUPPLIER = "SUPPLIER",
}

export const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9._+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return !regex.test(String(email).toLowerCase()) || validateEmailDomain(email);
};

const validateEmailDomain = (email) => {
  const regexEmail = new RegExp(process.env.REACT_APP_USER_EMAIL_VALIDATOR);
  return regexEmail.test(String(email).toLowerCase());
};
